import React from 'react'
import { graphql, gql } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import { translate } from 'react-i18next'

import { Form, TextAreaInput } from '../../UI'
import Loader from '../../UI/Loader'

import { validateRequired, validateLength } from '../../../libs/validation'
import { NotificationManager } from 'react-notifications'
import USER_QUERY from './../../../graphql/UserByID.graphql'
import get from 'lodash/get'

class ServiceDescriptionForm extends React.Component {
  state = {
    saving: false,
    routeIndex: 8
  }

  componentWillMount() {
    if (!this.props.data.loading && !this.props.data.user.plannerProfile) {
      this.props.history.push('/create-guru-profile/description')
    }
  }

  handleSubmit = values => {
    this.props.validate(this.state.routeIndex, true)
    this.setState({
      saving: true
    })
    const { plannerProfile } = this.props.data.User
    this.props
      .updatePlannerProfile({
        variables: {
          id: plannerProfile.id,
          serviceDescription: values.serviceDescription
        }
      })
      .then(() => {
        this.props.data.refetch()
        NotificationManager.success('Service description updated', 'Success', 5000)
        this.setState(
          () => ({
            saving: false
          }),
          () => {
            this.props.history.push('/create-guru-profile/trips')
          }
        )
      })
      .catch(err => {
        this.setState(() => ({
          saving: false
        }))

        NotificationManager.error('Error while updating service description', 'Error', 5000)
      })
  }

  render() {
    if (this.props.data.loading) {
      return <Loader showLoader={true} />
    }

    const { t } = this.props

    const serviceDescription = this.props.data.user.plannerProfile ? this.props.data.user.plannerProfile.serviceDescription : ''
    const { saving } = this.state
    return (
      <div className="steps-screen__form faded-container">
        <div className="steps-screen__form-title">{t('service_description_title')}</div>
        <Form
          onSubmit={this.handleSubmit}
          submitBtnClassname="btn btn-lg btn-primary btn-danger"
          submitBtnName={t('main:save_continue')}
          submittingToServer={saving}
        >
          <div className="steps-screen__form-input-area">
            <div className="steps-screen__form-subtitle">{t('customer_service_expectation')}</div>
            <div className="form-input-example">{t('service_description_example')}</div>
            <TextAreaInput
              id="serviceDescription"
              placeholder={t('service_description_message')}
              initialValue={serviceDescription}
              maxChars={800}
              validationFuncs={[validateRequired, validateLength]}
            />
          </div>
        </Form>
      </div>
    )
  }
}

const updatePlannerProfile = gql`
  mutation($id: ID!, $serviceDescription: String!) {
    updatePlannerProfile(id: $id, serviceDescription: $serviceDescription) {
      id
    }
  }
`

const userQuery = gql`
  query userQuery {
    user {
      id
      plannerProfile {
        id
        serviceDescription
      }
    }
  }
`

const TranslatedServiceDescriptionForm = translate('guru')(ServiceDescriptionForm)

export default graphql(updatePlannerProfile, {
  name: 'updatePlannerProfile'
})(
  graphql(USER_QUERY, {
    options: props => ({
      variables: {
        id: get(props, 'user.id', '')
      },
      options: {
        fetchPolicy: 'network-only'
      }
    })   
  })
  (withRouter(TranslatedServiceDescriptionForm))
)



// WEBPACK FOOTER //
// src/components/Guru/CreateGuruProfile/ServiceDescriptionForm.jsx